import { useEffect, useState } from "react";

const LEVELS = {
  elementary: { en: "Elementary", fr: "Primaire" },
  highschool: { en: "High school", fr: "Secondaire" },
  cegep: { en: "CEGEP", fr: "Cégep" },
};

let isFrench = false;
const listeners = new Set();
const watched = new WeakSet();
let observer;

function cookieValue(name) {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : "";
}

function readFrench() {
  const gadget = document.querySelector("#google_translate_element .goog-te-gadget-simple");
  if (gadget) {
    const label = (gadget.textContent || "").toLowerCase();
    if (label.includes("english") || label.includes("anglais")) return false;
    if (label.includes("french") || label.includes("français") || label.includes("francais")) return true;
  }
  const choice = cookieValue("googtrans");
  if (choice.endsWith("/en")) return false;
  if (choice.endsWith("/fr")) return true;
  return false;
}

function ensureObserver() {
  if (observer) return;
  const update = () => {
    const next = readFrench();
    if (next === isFrench) return;
    isFrench = next;
    listeners.forEach((listener) => listener(next));
  };
  const watchGadget = () => {
    const el = document.getElementById("google_translate_element");
    if (!el || watched.has(el)) return;
    watched.add(el);
    observer.observe(el, { childList: true, subtree: true, characterData: true });
    update();
  };
  isFrench = readFrench();
  observer = new MutationObserver(() => {
    watchGadget();
    update();
  });
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"],
  });
  observer.observe(document.body, { childList: true, subtree: true });
  watchGadget();
}

export function useLevelLabel(level) {
  const [french, setFrench] = useState(() => readFrench());

  useEffect(() => {
    ensureObserver();
    setFrench(isFrench);
    listeners.add(setFrench);
    return () => listeners.delete(setFrench);
  }, []);

  const names = LEVELS[level];
  return french ? names.fr : names.en;
}

export function LevelName({ level }) {
  const label = useLevelLabel(level);
  return (
    <span className="notranslate" translate="no">
      {label}
    </span>
  );
}
